<template lang="pug">
  v-row
    v-col(cols="12")
      slot

    v-col(
      cols="12"
      :class="{ 'py-0': !hasError }"
    )
      dv-input(
        v-bind="$attrs"
        v-on="$listeners"
        hide-details="auto"
        :value="value"
        @update:error="hasError = $event"
      )
</template>

<script>
import DvInput from './DvInput.vue';

export default {
  components: {
    DvInput,
  },
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: undefined,
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      hasError: false,
    };
  },
};
</script>
